module.exports = __webpack_public_path__ + "img/Slide43.a728e62d.png";